import {Component, input} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-tooltip',
    standalone: true,
    imports: [NgbPopover],
    template: `<i
        [class]="customClass()"
        [autoClose]="'outside'"
        popoverClass="custom-popover"
        container="body"
        [ngbPopover]="popover()"></i>`,
})
export class TooltipComponent {
    popover = input.required<string>();
    customClass = input<string>('bi bi-info-circle ms-3');
}
